import { render, staticRenderFns } from "./DeleteAddress.vue?vue&type=template&id=3eae9ad2"
import script from "./DeleteAddress.vue?vue&type=script&lang=js"
export * from "./DeleteAddress.vue?vue&type=script&lang=js"
import style0 from "./DeleteAddress.vue?vue&type=style&index=0&id=3eae9ad2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports